/** @jsxFrag React.Fragment */

/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Skeleton, Typography, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/account-profile';

const styles = {
  section: () => css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

export const AdditionalInfoSkeletonLoader = () => {
  return (
    <>
      <Typography variant="h2semibold" data-testid="additional-info-section-loaader" css={styles.section}>
        {_t('Additional info')}
      </Typography>
      <Typography2 component="p" css={styles.section}>
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </Typography2>
      <Typography2 component="h3" css={styles.section} variant="subtitleMedium">
        {_t('Links & Resume')}
      </Typography2>
      <Typography2 component="p">
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </Typography2>
    </>
  );
};

export default AdditionalInfoSkeletonLoader;
